<template>
  <div>
    <template v-if="!stidlistLengthStatus">
      <ReportFristTotal
        v-if="totalTableShow"
        :objectdata="gametotalItems"
        :title="'全部'"
        :loading="loading"
      />
      <lida-table
        v-for="(it, key) in items"
        :key="key"
        :propscolumns="columns"
        :data="it"
        :sortStatus="false"
        class="my-2"
        align="right"
        :SpinLoading="loading"
        :propsPageSize="50"
        :LeaveSpace="false"
      >
        <template v-slot:headerSelect>
          <p class="title text-left">{{getGamename(key)}}</p>
        </template>
      </lida-table>
    </template>
    <template v-else>
      <ReportFristTotal
        class="my-2"
        v-for="it in sitedata"
        :objectdata="it.tableData"
        :title="it.stname"
        :stid="it.stid"
        :key="it.stid"
      />
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import switchHie from '@/views/ledger/mixins/switchHie'
import reportCount from '@/mixins/report-count.js'
import { markSates } from '@/plugins/utils/game-id-filter.js';
import acountData from '@/mixins/acount-data'
import ReportFristTotal from '@/views/ledger/assort-ledger/ReportFristTotal.vue'
export default {
  name: 'report-frist',
  mixins: [reportCount, switchHie, acountData],
  components: {
    ReportFristTotal
  },
  data () {
    return {
      items: {},
      gametotalItems: {},
      notSunArray: ['gameid', 'buid', 'name', 'pmid', 'l1tlpa', 'l1total'],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck', 'getAllGame']),
    totalTableShow () {
      return this.$route.meta.repnum == '1'
    },
    columns () {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 40
        },
        gameid: {
          title: '游戏项目',
          align: 'center',
          key: 'gameid',
          width: 120,
          render: (h, params) => {
            if (params.row.name !== '总计') {
              const gameid = params.row.gameid || this.query.gameid
              const list = this.getalllist.find(it => it.gameid == gameid)
              return h('p', list.gamename)
            }
          },
        },
        name: {
          title: '投注选项',
          align: 'center',
          key: 'name',
          minWidth: 100,
          totaltext: '总计',
          render: (h, params) => {
            let name = params.row.name || params.row.gamecodename
            return this.checkFooterText(name)
              ? h('p', name)
              : h('a', {
                on: {
                  click: () => this.reportNative(params.row)
                }
              }, name)
          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          width: 50,
          total: true,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        sumval: {
          title: '下注金额',
          align: 'center',
          key: 'sumval',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'sumval')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 20,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        pal: {
          title: '会员盈亏',
          align: 'center',
          key: 'pal',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'pal')
        },
        lupps: {
          title: `${this.levelName[1]}占成上缴`,
          align: 'center',
          key: 'lupps',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'lupps')
        },
        l1total: {
          title: `${this.levelName[1]}上缴%`,
          align: 'center',
          key: 'l1total',
          render: (h, params) => {
            if (params.row.name !== '总计') {
              const l1total = params.row.l1total
              return !this.checkFooterText(params.row.name) ? h('p', `${l1total > 0 ? ((params.row.l1tl / l1total) * 100).toFixed(2) : 0}%`) : null
            }
          },
        },
        lupt: {
          title: `${this.levelName[1]}上缴`,
          align: 'center',
          key: 'lupt',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'lupt')
        },
        odddiffval1: {
          title: `${this.levelName[1]}差价数`,
          align: 'center',
          key: 'odddiffval1',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'odddiffval1')
        },
        l1tltotal: {
          title: `${this.levelName[0]}占成(%)`,
          align: 'center',
          key: 'l2p',
          render: (h, params) => {
            const value = params.row.effval != 0 ? ((params.row.l1tl / params.row.effval) * 100).toFixed(2) : 0
            return !this.checkFooterText(params.row.name) ? h('span', `${value}%`) : null
          },
        },
        l1tl: {
          title: `${this.levelName[0]}占成`,
          align: 'center',
          key: 'l1tl',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1tl')
        },
        kekka: {
          title: `${this.levelName[0]}占成盈亏`,
          align: 'center',
          key: 'kekka',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'kekka')
        },
        l1pds: {
          title: `${this.levelName[0]}赚佣`,
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
        Cbonus: {
          title: `${this.levelName[0]}补货奖金`,
          align: 'center',
          key: 'Cbonus',
          total: true,
          render: (h, params) => h('p', params.row.Cbonus)
        },
        bupayds: {
          title: `${this.levelName[0]}补货佣金`,
          align: 'center',
          key: 'bupayds',
          total: true,
          render: (h, params) => h('p', params.row.bupayds)
        },
        cpal: {
          title: `${this.levelName[0]}盈亏`,
          align: 'center',
          key: 'cpal',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'cpal')
        },
      }
      return object
    },
    apiData () {
      const { iscal, stdate, endate, buid, odddtl, mark, username } = this.query
      const gameid = this.$route.meta.repnum == '1' ? this.query.gmclist : Number(this.query.gameid)
      let result
      switch (this.$route.meta.repnum) {
        case '1':
          result = {
            repnum: 1,
            gmclist: gameid,
            stdate,
            endate,
            stidlist: this.query.stidlist,
            iscal,
            username
          }
          break;
        case '2':
          result = {
            repnum: 2,
            gameid,
            stdate,
            endate,
            buid,
            stid: this.query.stidlist,
            iscal,
            username
          }
          if (this.judgeExgame(Number(gameid))) {
            result.repnum = 12
            result['iscq9'] = true
            delete result.buid
          }
          break;
        case '3':
          result = {
            repnum: 3,
            gameid,
            stdate,
            endate,
            buid,
            odddtl,
            mark,
            stid: this.query.stidlist,
            iscal,
            troddid: this.query.troddid,
            username
          }
          if (this.judgeExgame(Number(gameid))) {
            result.repnum = 14
            result['iscq9'] = true
            delete result.buid
            delete result.odddtl
            delete result.troddid
          } else {
            if (result.troddid == undefined) result.troddid = result.mark
          }
          break;
        default:
          break;
      }
      return result
    },
    levelName () {
      let levelArray = this.acountData.map(item => item.name)
      return levelArray
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () { // 跟api 拿资料
      this.loading = true
      try {
        const res = await this.$axios.assortLedger.assortLedgerReport(this.apiData)
        if ('status' in res && res.status === 0) return
        if (!this.stidlistLengthStatus) {
          let data = this.$route.meta.repnum == 1 ? res[0].data : res
          this.modifyRes(data)
        }
        if (this.stidlistLengthStatus) this.getSitedataAssort(res)
        this.loading = false
      } catch (error) {
        console.error(error);
        this.$Message.error("请勿改动网站资讯!");
        this.$router.push({ name: this.$route.matched[1].name })
        this.loading = false
      }
    },
    modifyRes (result, obj) {
      let l1totalAll = 0
      if (Array.isArray(result)) return this.modifyData(this.stidlistLengthStatus, true, obj)
      const data = Object.keys(result).reduce((acc, val) => { // 遍例游戏列表table 预设值, 计算分公司占城上缴总和
        const l1total = this.l1totalReduce(result[val], 'l1tl')
        l1totalAll += l1total
        acc[val] = result[val].map(it => {
          if (this.$route.meta.repnum == '2') it.name = it.oddname
          if (this.$route.meta.repnum == '3') it.name = `${it.deoddsrepname} ${it.mark}`
          if ('l1total' in it == false) it.l1total = 0
          it.l1total = l1total
          it.gameid = val
          it.bupayds = 0
          it.Cbonus = 0
          return it
        })
        return acc
      }, {})
      this.modifyData(this.stidlistLengthStatus, false, obj, l1totalAll, data)
    },
    modifyData (status1, status2, obj, l1totalAll, data) {
      //status1 是否為多選站別 status2api拉回來的資料是否回空值 l1totalAll data有資料後傳值
      if (status2) {
        if (status1) {
          this.sitedata.push({ tableData: {} })
          this.sitedata[obj.index]["stid"] = obj.stid
          this.sitedata[obj.index]["stname"] = obj.stname
        } else {
          this.items = this.itemsDefault()
        }
      } else {
        if (status1) {
          this.sitedata.push({ tableData: { l1totalAll, data } })
          this.sitedata[obj.index]["stid"] = obj.stid
          this.sitedata[obj.index]["stname"] = obj.stname
        } else {
          this.items = { ...this.itemsDefault(), ...data }
          this.gametotalItems = { l1totalAll, data }
        }
      }
    },
    getSitedataAssort (arr) {//多選站別塞入資料
      arr.forEach((it, index) => {
        this.modifyRes(it.data, { index, stid: it.stid, stname: it.stname })
      })
    },
    itemsDefault () {
      let arr = this.query.gameid || this.query.gmclist
      const length = arr.split(',')
      let result = length.reduce((acc, val) => (acc[val] = [], acc), {})
      this.loading = false
      return result
    },
    reportNative (value) {
      let path
      let query = JSON.parse(JSON.stringify(this.query))
      for (let i in query) {
        query[i] = query[i]
      }
      switch (this.$route.meta.repnum) {
        case '1':
          path = { name: 'assort-ledger-report2', query: { ...this.query, buid: !value.buid ? 0 : value.buid, gameid: value.gameid }, params: this.$route.params }
          break;
        case '2':
          const gameid = this.query.gameid
          if (!this.judgeExgame(gameid)) {
            path = { name: 'assort-ledger-report3', query: { ...this.query, odddtl: this.judgeExgame(gameid) ? 0 : value.odddtl, mark: this.judgeExgame(gameid) ? (value.gamecode) : value.mark, troddid: this.judgeExgame(gameid) ? 0 : value.troddid }, params: { ...this.$route.params } }
          } else {
            path = { name: 'assort-ledger-report4', query: { ...this.query, gameid: gameid, odddtl: this.judgeExgame(gameid) ? 0 : value.odddtl, mark: this.judgeExgame(gameid) ? (value.gamecode || 'all') : value.mark, troddid: this.judgeExgame(gameid) ? 0 : value.troddid, gamename: this.judgeExgame(gameid) ? value.gamecodename : 0 }, params: this.$route.params }
          }
          break;
        case '3':
          path = { name: 'assort-ledger-report4', query: { ...this.query, mark: value.mark, troddid: value.troddid }, params: this.$route.params }
          break;
        default:
          break;
      }
      this.$router.push(path)
    },
    judgeExgame(gameid) { // 判斷外站遊戲
      return gameid >= 101 && gameid <= 200
    }

  }
}
</script>